/**
 * Analytics Service
 */
import axios from 'axios';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();

const analyticsApi = axios.create({
  baseURL: `${API_URL}/api/analytics`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const analyticsService = {
  async getPortfolio(userId) {
    const response = await analyticsApi.get(`/portfolio/${userId}`);
    return response.data;
  },

  async getTradeHistory(userId, limit = 50) {
    const response = await analyticsApi.get(`/trades/${userId}`, { params: { limit } });
    return response.data;
  },

  async getPriceHistory(token, period = '24h') {
    const response = await analyticsApi.get(`/prices/${token}/history`, { params: { period } });
    return response.data;
  },

  async getCurrentPrice(token) {
    const response = await analyticsApi.get(`/prices/${token}/current`);
    return response.data;
  },

  async getNotifications(userId, unreadOnly = false, limit = 50) {
    const response = await analyticsApi.get(`/notifications/${userId}`, {
      params: { unread_only: unreadOnly, limit },
    });
    return response.data;
  },

  async markNotificationsRead(userId) {
    const response = await analyticsApi.post(`/notifications/${userId}/mark-read`);
    return response.data;
  },

  async createPriceAlert(userId, token, condition, targetPrice) {
    const response = await analyticsApi.post('/alerts/create', {
      user_id: userId,
      token,
      condition,
      target_price: targetPrice,
    });
    return response.data;
  },

  async getActiveAlerts(userId) {
    const response = await analyticsApi.get(`/alerts/${userId}`);
    return response.data;
  },
};

export default analyticsService;
